module.exports = __webpack_public_path__ + "static/media/NotificationIcon.82b139cb.svg";